import axios from "axios";

const url = process.env.REACT_APP_BACKEND_HOST.concat("/spot/");

export async function fixInstructorsStudentRole(token, term, empids) {
	return new Promise((resolve, reject) => {
		axios({
			method: "put",
			url: url + "fix_instructors_student_role/",
			headers: {
				Authorization: `Token ${token}`,
			},
			data: { term: term, empids: empids },
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				reject(error);
				console.log("error");
				console.log(error);
			});
	});
}

export async function updateRFSData(token, reqnum, rfsData) {
	return new Promise((resolve, reject) => {
		axios({
			headers: {
				Authorization: `Token ${token}`,
				"Content-Type": "application/json",
			},
			method: "PUT",
			url: process.env.REACT_APP_BACKEND_HOST.concat("/scanner/update_scanner_requisition/")
				.concat(reqnum)
				.concat("/"),
			data: rfsData,
		})
			.then((response) => {
				if (response.status === 201) {
					resolve(response);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function toggleBulkGradesSubmitted(token, classids, operation) {
	return new Promise((resolve, reject) => {
		axios({
			method: "put",
			url: url + "toggle_bulk_grades_submitted/",
			headers: {
				Authorization: `Token ${token}`,
			},
			data: { classids: classids, operation: operation },
		})
			.then((response) => {
				if (response.status === 200) {
					resolve(response);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function updateDepartmentOptStatus(token, dept_id, grades_finalized) {
	return new Promise((resolve, reject) => {
		axios({
			method: "put",
			url: url + "update_department_opt_status/",
			headers: {
				Authorization: `Token ${token}`,
			},
			data: { dept_id: dept_id, grades_finalized: grades_finalized },
		})
			.then((response) => {
				if (response.status === 204) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function updateConfirmExamDate(token, classid, examdate) {
	return new Promise((resolve, reject) => {
		axios({
			method: "put",
			url: url + "update_examdates_confirm".concat(`/${classid}`).concat(`/${examdate}/`),
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 204) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function updateRequisitionDates(token, reqnum, startDate, endDate) {
	return new Promise((resolve, reject) => {
		axios({
			method: "put",
			url:
				url +
				"update_requisition_dates"
					.concat(`/${reqnum}`)
					.concat(`/${startDate}`)
					.concat(`/${endDate}/`),
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 204) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function updateClassIdTeamSize(token, classid, teamsize) {
	return new Promise((resolve, reject) => {
		axios({
			method: "put",
			url: url + "update_classid_teamsize".concat(`/${classid}`).concat(`/${teamsize}/`),
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 204) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function updateTrackToggles({ token, changes }) {
	return new Promise((resolve, reject) => {
		axios({
			method: "put",
			url: url + "update_track_toggles/",
			data: changes,
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 204) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function updateClassAdjust({ token, selectedClass, ccid }) {
	return new Promise((resolve, reject) => {
		axios({
			method: "put",
			url: url + "update_class_adjust/",
			data: { selectedClass: selectedClass, ccid: ccid },
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 204) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}

export async function updateMidtermToggles({ token, changes }) {
	return new Promise((resolve, reject) => {
		axios({
			method: "put",
			url: url + "update_midterm_toggles/",
			data: changes,
			headers: {
				Authorization: `Token ${token}`,
			},
		})
			.then((response) => {
				if (response.status === 204) {
					resolve(response.data);
				}
			})
			.catch((error) => {
				console.log(error);
				reject(error);
			});
	});
}
